/**
 * What a figure fence shows at a given moment. Pure, so the streaming rules
 * are unit-testable without React:
 *
 * - `figure`: a chart spec or diagram SVG is ready.
 * - `skeleton`: nothing is ready yet but there is still reason to expect a
 *   figure — the message is still streaming (the fence body is incomplete),
 *   or mermaid is still loading or rendering a complete body.
 * - `source`: the fence will not become a figure — the message has finished
 *   and the body does not parse — or the reader asked for the code.
 */
export type FigureView = "figure" | "skeleton" | "source";

export interface FigureStateInput {
  /** The reader flipped to the source view. */
  readonly showSource: boolean;
  /** A chart spec or diagram SVG is available to show. */
  readonly ready: boolean;
  /** The message that carries the fence is still streaming. */
  readonly isStreaming: boolean;
  /** The current body was tried and cannot become a figure. */
  readonly failed: boolean;
}

export function resolveFigureView({
  showSource,
  ready,
  isStreaming,
  failed,
}: FigureStateInput): FigureView {
  if (showSource) return "source";
  if (ready) return "figure";
  if (isStreaming) return "skeleton";
  return failed ? "source" : "skeleton";
}
